import { loadStripe, Stripe } from '@stripe/stripe-js';

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const proPriceId = import.meta.env.VITE_STRIPE_PRO_PRICE_ID;
const customerPortalUrl = import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL_URL;

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = () => {
  if (!stripePromise && stripePublishableKey) {
    stripePromise = loadStripe(stripePublishableKey);
  }
  return stripePromise;
};

export const STRIPE_CONFIG = {
  publishableKey: stripePublishableKey || '',
  proPriceId: proPriceId || '',
  customerPortalUrl: customerPortalUrl || '',
  isConfigured: Boolean(stripePublishableKey && proPriceId),
};
